{
  "duplicateShortName": "Attribute/Filter Name already in use. Please select a different name",
  "shortNameError": "Short Name is invalid"
}